import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import styles from './ReferralBanner.module.css';

/**
 * Aviso de quem indicou, para quem chegou pelo link `/i/CODIGO`.
 * Fica fixo embaixo, fora do caminho do cabeçalho fixo da landing.
 * @param {Object} props
 * @param {string} props.name nome da conta que indicou
 * @param {Function} props.onCreateAccount
 * @param {Function} props.onDismiss
 */
function ReferralBanner({ name, onCreateAccount, onDismiss }) {
  return (
    <div className={styles.banner} role="status">
      <div className={styles.text}>
        <span className={styles.label}>Indicação de {name}</span>
        <span className={styles.detail}>Crie sua conta e teste a Gabriela por 30 dias sem pagar nada.</span>
      </div>
      <button type="button" className={styles.button} onClick={onCreateAccount}>
        Criar conta
      </button>
      <button type="button" className={styles.close} onClick={onDismiss} aria-label="Fechar">
        <CloseIcon fontSize="inherit" />
      </button>
    </div>
  );
}

export default ReferralBanner;
